import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// 自定义语言检测器：根据浏览器语言自动选择
// zh-CN / zh-SG → 简体中文
// zh-TW / zh-HK / zh-MO → 繁体中文
// 其他语言 → 英文
const customGeoDetector = {
  name: 'customGeoDetector',

  lookup() {
    const navLang = navigator.language || (navigator as any).userLanguage || (navigator as any).browserLanguage || '';
    const lang = navLang.toLowerCase();

    // 繁体中文区域
    if (lang.startsWith('zh-tw') || lang.startsWith('zh-hk') || lang.startsWith('zh-mo')) {
      return 'zh-TW';
    }

    // 简体中文区域（中国大陆、新加坡等）
    if (lang.startsWith('zh')) {
      return 'zh';
    }

    // 其他所有语言 → 英文
    return 'en';
  },

  cacheUserLanguage(lng: string) {
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch {
      // localStorage 不可用时忽略
    }
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customGeoDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    lng: undefined, // 让检测器自动决定
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    detection: {
      order: ['customGeoDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

// 切换语言的辅助函数
export function switchLanguage(lang: string) {
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem('i18nextLng', lang);
  } catch {
    // ignore
  }
}